import React from "react";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FormattedMessage, injectIntl } from "react-intl";

import MailingDialog from "components/mailing/MailingDialog";
import SearchByManufacturer from "components/search/manufacturer/SearchByManufacturer";
import CategoryTree from "components/categorytree/CategoryTree";
import BaseComponent from "base";
import { Box, Button, Typography, InputAdornment, IconButton, Popover } from "@mui/material";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import SearchIcon from "@mui/icons-material/Search";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";

class SidebarView extends BaseComponent {
  constructor(props) {
    super(props);
  }

  state = {
    manufacturer: "",
    searchText: "",
    categoryId: null,
    activePrices: true,
    activePricesInfoAnchorEl: null,
  };

  componentDidUpdate(prevProps) {
    Object.keys(this.state).forEach((stateKey) => {
      if (prevProps[stateKey] !== this.props[stateKey]) {
        const stateUpdate = {};
        stateUpdate[stateKey] = this.props[stateKey];
        setTimeout(() => this.setState(stateUpdate));
      }
    });
  }

  onSearchChange(searchText) {
    if (this.props.onSearchTextChanged) {
      this.props.onSearchTextChanged(searchText);
    }
    this.setState({ searchText });
  }

  onCategoryChanged(categoryId) {
    if (this.props.onCategoryChanged) {
      this.props.onCategoryChanged(categoryId);
    }
    this.setState({ categoryId });
  }

  onManufacturerChanged(manufacturer) {
    if (this.props.onManufacturerChanged) {
      this.props.onManufacturerChanged(manufacturer);
    }
    this.setState({ manufacturer });
  }

  onUserListLoaded(products, categoryId) {
    if (this.props.onUserListLoaded) {
      this.props.onUserListLoaded(products, categoryId);
    }

    this.onCategoryChanged(categoryId);
  }

  onResetClicked() {
    this.onManufacturerChanged(null);
    this.onCategoryChanged(null);
    this.onSearchChange(null);

    if (this.props.onResetClicked) {
      this.props.onResetClicked();
    }
  }

  onSearchClicked() {
    if (this.props.onSearchClicked) {
      this.props.onSearchClicked();
    }
  }

  onResetSearch() {
    this.setState({
      manufacturer: "",
      searchText: "",
      categoryId: null,
      activePrices: true,
    });
    if (this.props.onActivePricesChanged) {
      this.props.onActivePricesChanged(true);
    }
    if (this.props.onResetSearchFilters) {
      this.props.onResetSearchFilters();
    }
  }

  renderButtons() {
    return (
      <div className="left">
        <MailingDialog className={"actions"} />
      </div>
    );
  }

  render() {
    return (
      <div className={"sidenavContent"}>
        {/* {this.renderButtons()} */}
        <form
          onSubmit={(evt) => {
            evt.preventDefault();
            this.onSearchClicked();
          }}>
          <div>
            <SearchByManufacturer onChange={this.onManufacturerChanged.bind(this)} onSubmitSearch={this.onSearchClicked.bind(this)} value={this.state.manufacturer} />

            <TextField
              label={this.props.intl.formatMessage({ id: "search.searchPlaceholder" })}
              fullWidth
              variant="standard"
              value={this.state.searchText ?? ""}
              onChange={(evt) => this.onSearchChange(evt.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <KeyboardReturnIcon sx={{ fontSize: "16px", color: "#00000099" }} />
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: "12px", textTransform: "uppercase" }}>
                <FormattedMessage id="search.pressEnterToSearch" />
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", marginTop: "1em", width: "100%", gap: 2 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    checked={this.state.activePrices}
                    onChange={(evt) => {
                      const checked = evt.target.checked;
                      this.setState({ activePrices: checked });
                      if (this.props.onActivePricesChanged) {
                        this.props.onActivePricesChanged(checked);
                      }
                    }}
                  />
                }
                label={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
                    <FormattedMessage id="search.activePricesOnly" />
                    <IconButton
                      size="small"
                      aria-label="Visa information"
                      onClick={(evt) => {
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.setState({ activePricesInfoAnchorEl: evt.currentTarget });
                      }}>
                      <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
                    </IconButton>
                  </Box>
                }
                sx={{
                  margin: 0,
                  alignItems: "center",
                  flex: "0 0 auto",
                  maxWidth: "100%",
                  "& .MuiFormControlLabel-label": { fontSize: "0.875rem", lineHeight: 1.25 },
                }}
              />
              <Popover
                open={Boolean(this.state.activePricesInfoAnchorEl)}
                anchorEl={this.state.activePricesInfoAnchorEl}
                onClose={() => this.setState({ activePricesInfoAnchorEl: null })}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}>
                <Box sx={{ position: "relative", maxWidth: 260, padding: 2, paddingRight: 4 }}>
                  <IconButton
                    size="small"
                    aria-label="Stäng information"
                    onClick={() => this.setState({ activePricesInfoAnchorEl: null })}
                    sx={{ position: "absolute", right: 4, top: 4 }}>
                    <CloseIcon sx={{ fontSize: "16px" }} />
                  </IconButton>
                  <Typography variant="body2">
                    <FormattedMessage id="search.activePricesOnlyInfo" />
                  </Typography>
                </Box>
              </Popover>
              <Box sx={{ display: "flex", gap: 0.5, flex: "0 0 auto", flexShrink: 0, marginLeft: "auto" }}>
                <Button type="submit" variant="contained" color="primary" size="small" sx={{ fontSize: "0.8rem" }}>
                  <FormattedMessage id="search.searchButton" />
                </Button>
                <Button type="button" variant="contained" color="secondary" size="small" sx={{ fontSize: "0.8rem" }} onClick={this.onResetSearch.bind(this)}>
                  <FormattedMessage id="search.clearButton" />
                </Button>
              </Box>
            </Box>
          </div>
        </form>

        <CategoryTree selectedId={this.state.categoryId} onChange={this.onCategoryChanged.bind(this)} resetTreeTrigger={this.props.resetTreeTrigger} />
      </div>
    );
  }
}

export default injectIntl(SidebarView);
